import queryString from "querystring";

export default (params) => {
    const query = params.replace("?", "");
    return queryString.parse(query);
};
